import React from "react";

import { Mobile, TabletMobile, NotMobile } from "../../../common/Responsive";
import { HeaderLogo } from "../../../components/layout/headerComponents/headerLogo/HeaderLogo";
import {
  HeaderTitle,
  HeaderTitleCompact,
} from "../../../components/layout/headerComponents/headerTitle/HeaderTitle";
import { BaseHeader } from "../../../components/layout/headerComponents/baseHeader/BaseHeader";
import { MobileNavigationMenu } from "./MobileNavigationMenu/MobileNavigationMenu";

import "./HelpHeader.scss";

export const HelpHeader = () => (
  <BaseHeader className="help-header">
    <NotMobile>
      <div className="help-header__content-left">
        <HeaderLogo />
        <HeaderTitle />
      </div>
    </NotMobile>
    <Mobile>
      <div className="help-header__content-left">
        <HeaderTitleCompact />
      </div>
    </Mobile>
    <TabletMobile>
      <div className="common-header__content-right">
        <MobileNavigationMenu />
      </div>
    </TabletMobile>
  </BaseHeader>
);
